import { useMemo } from "react";
import { usePlayerLib } from "@kaltura/mediaspace-shared-utils";
import { MediaPlayerV3 } from "@kaltura/mediaspace-shared-player";
import styled from "@emotion/styled";

export interface BaseUploadPlayerData {
    entryId: string;
    thumbnailUrl: string;
    playerConfig: any;
}

export interface UploadPreviewPlayerProps<DataT extends BaseUploadPlayerData = BaseUploadPlayerData> {
    data: DataT;
}

/**
 * Component that displays preview of the uploaded video in a player.
 */
export const UploadPreviewPlayer = <DataT extends BaseUploadPlayerData>({
    data: { entryId, playerConfig },
}: UploadPreviewPlayerProps<DataT>) => {
    const { ks } = playerConfig;

    const media = useMemo(() => ({ entryId, ks }), [entryId, ks]);

    const { libLoaded } = usePlayerLib(playerConfig.provider.uiConfId);
    if (!libLoaded) {
        return <StyledNoPlayer />;
    }

    return <MediaPlayerV3 media={media} config={playerConfig} />;
};

const StyledNoPlayer = styled("div")({
    width: "100%",
    height: "100%",
    // not themable, just black
    background: "#000",
});
